import styled from "styled-components";
import styles from "../styles";
import Footer from "./Footer";

const S = {
	PdfPage: styled.div`
      position: relative;
      overflow: hidden;
      height: 1020px;
      width: 100%;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);

      // Add preview styling
      @media screen {
        margin: ${styles.pdfSpacing}px 0;
        padding: ${styles.pdfPadding}px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        border-radius: 12px;
        min-height: 1200px;
      }
    `,
	Content: styled.div`
      position: relative;
      z-index: 1;
      padding-bottom: 150px; // Space for footer
    `,
};

export default ({ children }: { children: any }) => (
	<S.PdfPage>
		<S.Content>{children}</S.Content>

		<Footer />
	</S.PdfPage>
);
